<template>
  <div class="product-review-summary-container">
    <div class="new-product-review-summary">
      <div class="product-review-summary-heading" :class="{ 'new-product-review-summary-single-row': !review.rating }">
        <h2 class="light new-pdp-title">
          <template v-if="reviewCount">{{ reviewCount }} </template> Review{{ reviewCount === 1 ? '' : 's' }}
        </h2>
        <div class="product-review-summary-details">
          <Rating v-if="review.rating" :max="5" :value="review.rating" :show-half-star="true"></Rating>
          <div v-if="ratingFormatted" class="product-review-rating-average">
            <span class="new-product-review-average-text accent" @click="$emit('ratingClicked')"> {{ ratingFormatted }}</span>
          </div>
          <div v-if="review.rating" class="product-review-vertical-spacer"></div>
          <div>
            <a class="small secondary product-review-link accent" :href="reviewUrl">
              <template v-if="isLoggedIn">Write a review</template>
              <template v-else> Log in to review</template>
            </a>
          </div>
          <div class="product-review-vertical-spacer"></div>
          <div>
            <a class="small secondary product-review-link accent" title="Our review policy" @click.passive="togglePolicy">Review Policy</a>
          </div>
        </div>
      </div>
      <div class="product-review-action-container">
        <div v-if="showActions" class="new-product-review-actions">
          <div class="product-review-loader"><div v-if="loading && !error" class="loader tiny" /></div>
          <SingleSelect
            v-if="reviewCount >= 5 && availableTagNames && availableTagNames.length"
            :modelValue="0"
            @update:modelValue="selectedTag($event)"
            class="star-filters-review"
            title="Topics:"
            :options="availableTagName"
          ></SingleSelect>
          <div v-if="reviewCount >= 5" class="product-review-action product-review-filter">
            <SingleSelect
              :modelValue="filterStar"
              @update:modelValue="$emit('updateStars', $event)"
              class="star-filters-review"
              title="Ratings:"
              :options="starFilterOptions"
            ></SingleSelect>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isPolicyShownMobile" class="product-page-container product-review-policy-container-mobile">
      <div class="review-policy-mobile">
        <ProductReviewPolicy></ProductReviewPolicy>
        <button @click="btnClicked" class="new-product-review-close button white filled icon"><span class="af af-close"></span></button>
      </div>
    </div>
    <div v-if="isPolicyShown" class="product-page-container product-review-policy-container-desktop">
      <ProductReviewPolicy></ProductReviewPolicy>
    </div>
  </div>
</template>
<script>
import { Select as SingleSelect } from '@/pixel/index';
import Rating from './Rating.vue';
import ProductReviewPolicy from './ProductReviewPolicy.vue';
import ReviewTags from './ReviewTags.vue';
import UserService from '@/services/UserService';

export default {
  components: {
    SingleSelect,
    Rating,
    ProductReviewPolicy,
    ReviewTags,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    filterStar: {
      type: String,
      default: 'ALL',
    },
    filterTag: {
      type: String,
      default: '',
    },

    availableTags: {
      type: Array,
      default: () => [],
    },
    reviewCount: {
      type: Number,
      default: 0,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: null,
    },
    reviewUrl: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isPolicyShown: false,
      isPolicyShownMobile: false,
      starFilterOptions: [
        { id: '', description: 'All reviews' },
        { id: '5', description: '5 star' },
        { id: '4', description: '4 star' },
        { id: '3', description: '3 star' },
        { id: '2', description: '2 star' },
        { id: '1', description: '1 star' },
      ],
    };
  },

  computed: {
    review() {
      return this.product && this.product.review ? this.product.review : {};
    },

    availableTagNames() {
      return (this.availableTags || []).map((tag) => tag.name);
    },

    ratingFormatted() {
      if (this.review && this.review.rating) {
        return Number(this.review.rating).toFixed(1).replace('.0', '');
      }
      return null;
    },
    availableTagName: function () {
      return [
        {
          id: 0,
          description: 'All Topics',
        },
        ...this.availableTagNames.map((tag, index) => ({
          id: index + 1,
          description: tag,
        })),
      ];
    },
  },

  created() {
    this.isLoggedIn = !!UserService.getUser()?.email;
  },

  methods: {
    togglePolicy() {
      if (window.matchMedia('(max-width: 970px)').matches) {
        this.disableScrolling();
        this.isPolicyShownMobile = !this.isPolicyShownMobile;
      } else {
        this.isPolicyShown = !this.isPolicyShown;
      }
    },

    btnClicked() {
      this.isPolicyShownMobile = !this.isPolicyShownMobile;
      window.onscroll = null;
    },

    selectedTag(event) {
      this.$emit('updateTags', this.availableTagNames[event - 1]);
    },
    disableScrolling() {
      let x = window.scrollX;
      let y = window.scrollY;
      window.onscroll = function () {
        window.scrollTo(x, y);
      };
    },
  },
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';

.product-review-summary-container {
  .product-review-policy-container-mobile {
    @media (min-width: 280px) and (max-width: calc($tablet-breakpoint - 1px)) {
      position: fixed;
      bottom: 0;
      overflow-y: scroll;
      overflow-x: hidden;
      top: 0;
      left: 0px;
      right: 0px;
      background-color: white;
      z-index: 10000;
      -webkit-overflow-scrolling: touch;
      touch-action: none;
    }
  }

  .product-review-policy-container-desktop {
    margin-top: var(--space-10);
    border-top: 1px solid var(--grey-ultra-light);
    border-bottom: 1px solid var(--grey-ultra-light);
    padding: var(--space-6) 0;
    margin-bottom: var(--space-10);
    .flex-grid {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
    }
    @media (min-width: $extra-small-breakpoint) and (max-width: calc($tablet-breakpoint - 1px)) {
      display: none;
    }
    .review-policy {
      max-width: 34em;
    }
  }

  .new-product-review-summary {
    display: flex;
    justify-content: space-between;

    @media (max-width: calc($tablet-breakpoint - 1px)) {
      display: block;
      flex-wrap: wrap;
    }
  }

  .product-review-summary-heading {
    min-width: 250px;
  }

  .product-review-rating-average {
    width: auto;
  }

  .product-review-vertical-spacer {
    margin-left: var(--space-4);
    border-left: 1px solid var(--grey-light);
    height: var(--space-3);
    text-decoration: underline;
    margin-right: var(--space-4);
  }
  .new-product-review-average-text {
    text-decoration: underline;
    cursor: pointer;
  }

  .product-review-summary-details {
    display: flex;
    align-items: center;
    flex-flow: wrap;
    margin-top: var(--space-1);
    line-height: 2;
  }

  .new-product-review-summary-single-row {
    display: flex;
    align-items: baseline;
    flex-direction: column;

    .product-review-summary-details {
      margin-top: 0;
    }
  }

  .product-review-action-container {
    width: 400px;
    align-self: center;
    @media (min-width: 280px) and (max-width: calc($tablet-breakpoint - 1px)) {
      width: calc(100vw - 40px);
    }
  }

  .new-product-review-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    @media (min-width: 280px) and (max-width: calc($tablet-breakpoint - 1px)) {
      display: block;
      width: inherit;
      margin-top: var(--space-8);
      paddding-left: 0.5px;
    }
  }

  .product-review-action {
    @media (min-width: 280px) and (max-width: calc($tablet-breakpoint - 1px)) {
      margin-top: var(--space-4);
    }
  }
  .new-product-review-close {
    top: var(--space-10);
    position: fixed;
    right: var(--space-5);
    overflow: hidden;
    z-index: 11;
    background: #ffffff;
    height: var(--space-10);
    @media (min-width: $tablet-breakpoint) {
      display: none !important;
    }
  }

  .review-tags-container {
    margin-top: var(--space-2);
  }

  .product-review-loader {
    @media (max-width: calc($mobile-breakpoint - 1px)) {
      display: none;
    }
  }

  .star-filters-review {
    margin-left: var(--space-4);
    width: auto;
    margin-right: 1px;
    .select-list {
      width: 100%;
    }
    @media (min-width: 280px) and (max-width: calc($tablet-breakpoint - 1px)) {
      width: auto;
      margin-left: 1px;
    }
  }
  .product-review-link {
    margin-left: var(--space-0);
  }

  .show-review-policy {
    display: flex;
    align-items: center;
    margin-left: var(--space-1);
    font-size: var(--font-size-12);
  }
}
.review-policy-mobile {
  position: absolute;
  height: 100%;
  overflow-y: auto;
  padding: var(--space-24) var(--space-5) var(--space-10) var(--space-0);
}

.product-page.heading {
  .new-pdp-title {
    font-size: 32px;
    color: var(--grey-dark);
    text-transform: none;
    letter-spacing: 0px;
    margin-bottom: var(--space-4);
  }
}
</style>
